import React, { useEffect, useRef, useState } from "react";
import "../../App.css";
import "../../styles/pages/about.css";

function WebMobileServices() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);   
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);
  return (
    <section className="section web-mobile-section">
      <div className="about-header">
        <h1 className="about-heading">About Us</h1>
      </div>
      <div className="aboutus-container">
        <div className="aboutus-content">
          <h2>About Us</h2>
          <p>
            We, <strong>GEOTECH</strong>  established in 2012 by seasoned professionals, is headquartered in the heart of Chennai. The company is dedicated to empowering users in the fields of GIS, IT, Agriculture, Health, Environment, Education & Research. With a significant presence in South India, Geotech has played a crucial role in setting up GIS/Remote Sensing laboratories and providing IT solutions to various Central and State Government departments, as well as private and research institutions. Further expanding its global reach, Geotech has successfully operated an overseas office in Singapore since 2022.
          </p>
        </div>
        {/*<div className="aboutus-image">
          <img
            src={`${process.env.PUBLIC_URL}/about_bg.jpg`}
            alt="About GEOTECH"
            className="aboutus-image__img"
          />
        </div>*/}
      </div>

      <div className="md-vision-below">
        <div className="md-vision__header">
          <h2 className="section__title">Our Mission & Vision</h2>
          <p className="section__intro">
            Discover the principles that guide GEOTECH's journey towards geospatial excellence
          </p>
        </div>
        <div className="vision-cards-row">
          <div className="vision-card mission-card">
            <div className="vision-card__icon">
              <span className="icon"></span>
            </div>
            <div className="vision-card__content">
              <h3>Our Mission</h3>
              <p>Our mission is to apply the latest concepts and methodologies to address complex challenges with efficiency and precision. By emphasizing continuous improvement, innovation, and a client-centric approach, Geotech is committed to setting high standards in GIS, IT, Health, Agriculture, Environment, Education, and Research, while contributing to sustainable growth and societal progress.</p>
            </div>
          </div>

          <div className="vision-card vision-card">
            <div className="vision-card__icon">
              <span className="icon"></span>
            </div>
            <div className="vision-card__content">
              <h3>Our Vision</h3>
              <p>Geotech aims to utilize innovative approaches and advanced solutions to become a leader in Geospatial Technology, IT, Health, Agriculture, Environment, Education, and Research.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="section__container1">
        <h2 className="section__title">QUALITY STANDARDS & SECURITY</h2>
        <div className="services-list">
          <p>Geotech holds certifications in ISO 9001:2015, ISO 27001:2022, and CMMI Level 3. These certifications ensure robust quality management and data security processes for effective product creation and service delivery.</p>
        </div>
      </div>

      <div 
        ref={sectionRef}
        className={`qualities-section ${isVisible ? 'animate' : ''}`}
        data-visible={isVisible}
      >
        <h2 className="section__title">UNIQUE QUALITIES</h2>
        <p className="section-subtitle">Geotech stands out in the Solutions Provider market with its distinct strengths</p>
        
        <div className="qualities-grid">
          <div className="quality-card">
            <div className="quality-card__image">
              <img src={`./ExpertiseandTeamwork.png`} alt="Expertise and Teamwork" />
            </div>
            <div className="quality-card__content">
              <h3>Expertise and Teamwork</h3>
              <p>Our team of seasoned professionals brings extensive experience and collaborative spirit to every project.</p>
            </div>
          </div>

          <div className="quality-card">
            <div className="quality-card__image">
              <img src={`./ClientCentricApproach.png`} alt="Client-centric approach" />
            </div>
            <div className="quality-card__content">
              <h3>Client-Centric Approach</h3>
              <p>We prioritize your needs, ensuring solutions are tailored to your specific requirements and goals.</p>
            </div>
          </div>

          <div className="quality-card">
            <div className="quality-card__image">
              <img src={`./QualityCommitment.png`} alt="Quality Commitment" />
            </div>
            <div className="quality-card__content">
              <h3>Quality Commitment</h3>
              <p>We maintain the highest standards in all our deliverables, ensuring excellence in every aspect.</p>
            </div>
          </div>

          <div className="quality-card">
            <div className="quality-card__image">
              <img src={`./InnovativeSolutions.png`} alt="Innovative Solutions" />
            </div>
            <div className="quality-card__content">
              <h3>Innovative Solutions</h3>
              <p>We leverage cutting-edge technology and creative thinking to deliver forward-thinking solutions.</p>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  );
}

export default WebMobileServices;